export { default as InfluencerMonthlyReportSlot } from './InfluencerMonthlyReportSlot';
